export default __webpack_public_path__ + "/dist/images/travel-agency.48cb01dc7498edeadf113d1cc33413b6.png";